import React, { useEffect, useState } from "react";

export type KeyFeatureProps = {
  attribute: string;
  title: string;
  description: string;
};

export default function ProductKeyFeatures({
  keyFeatures,
  title,
  highlight,
  description,
  titleHeight,
}: {
  keyFeatures: KeyFeatureProps[];
  title: string;
  highlight: string;
  description?: string;
  titleHeight?: number;
}) {
  const [before, after] = title.split(highlight);

  const [isMdUp, setIsMdUp] = useState(false);

  useEffect(() => {
    const checkWidth = () => setIsMdUp(window.innerWidth >= 768);
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);
  return (
    <section className="flex flex-col gap-10 items-center">
      <div className="flex justify-center items-start md:items-center w-full md:w-4/5  flex-col gap-4">
        <p className="flex items-center justify-center">
          <span className="bg-[#E7D7FD] text-base rounded-full px-3 py-1 text-[#8937F4] inline-block font-semibold">
            FEATURES
          </span>
        </p>
        <h2 className="md:text-[45px] text-2xl text-secondary-900 font-bold md:text-center leading-tight">
          {before}{" "}
          <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
            {highlight}
          </span>{" "}
          {after}
        </h2>
        {description ? (
          <span className="text-center text-base md:text-xl">
            {description}
          </span>
        ) : null}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
        {keyFeatures.map((feature) => (
          <div
            className="border rounded-lg p-4 flex flex-col gap-2  hover:bg-gradient-to-r hover:from-[#4337cc] hover:to-primary-900 group"
            key={feature.title}
          >
            <p className="flex items-center text-sm">
              <span className="bg-[#E5F6E8] rounded-full px-2 py-1 text-[#05551C] inline-block">
                {feature.attribute}
              </span>
            </p>
            <span
              className="text-secondary-900 text-xl md:text-[27px] font-bold group-hover:text-white leading-tight"
              style={
                isMdUp && titleHeight
                  ? { minHeight: `${titleHeight}px` }
                  : undefined
              }
            >
              {feature.title}
            </span>
            <span className="text-secondary-900 text-base md:text-lg font-medium group-hover:text-white">
              {feature.description}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
